import * as z from "zod";

export const getImsStatus = {
  name: "getImsStatus" as const,
  input: z.object({}),
  output: z.object({ isSourceOfTruth: z.boolean() }),
};
